import Notification from '../notification/notification';

export default new class SubscriptionPayment {
  constructor() {
    this.linkToPaymentFile = 'js-link-payment-file';
    if (!$(`.${this.linkToPaymentFile}`).length) return;
    this.initBindings();
  }

  initBindings() {
    $(document).on('click', `.${this.linkToPaymentFile}`, (e) => {
      e.preventDefault();
       const $body = $('body');
        const linkButton = $(e.currentTarget);
       const requestData = { order_id: linkButton.attr('data-order-id') };
      const format = linkButton.attr('data-format');
      $.request('UserSubscription::onGetPaymentFile', {
        data: requestData,
        success(response) {
          if (!response.status) {
            Notification.showError(response && response.message);

          }

          /* append hidden link on payment doc, trigger link click, remove link */
          const link = document.createElement('a');
          link.className = 'payment-doc';
          if (format == 'pdf') {
            link.download = 'cчет-фактура.pdf';
          } else {
            link.download = 'cчет-фактура.xlsx';
          }
          link.href = response.data;

          $body.append(link);
          link.click();
          $('.payment-doc').remove();

          this.success(response);
        },
      });
    });
  }
}();
